import React, { useState } from 'react';

function Roadmaps() {
  const [activeTab, setActiveTab] = useState('systems');

  const pathways = {
    systems: {
      title: 'Systems & Rust Engineer',
      steps: [
        {
          num: '01',
          phase: 'Phase 1: Foundations',
          title: 'Memory & Ownership',
          desc: 'Stack vs heap, pointer mechanics, borrow checker rules, smart pointers, and non-lexical lifetimes.',
          project: 'Project: Custom Memory Arena Allocator'
        },
        {
          num: '02',
          phase: 'Phase 2: Concurrency',
          title: 'Async & Lock-Free',
          desc: 'Tokio runtime, atomic memory orderings, crossbeam channels, and fearless multi-threading.',
          project: 'Project: Lock-Free SkipList Index'
        },
        {
          num: '03',
          phase: 'Phase 3: Production',
          title: 'High-Throughput Services',
          desc: 'Axum HTTP framework, SQLx connection pooling, Redis caching, and gRPC protocol buffers.',
          project: 'Project: 50,000 req/sec Matching Engine'
        },
        {
          num: '04',
          phase: 'Phase 4: Capstone',
          title: 'Architecture Defense',
          desc: 'Profiling with flamegraphs, static binary packaging, CI/CD, and live defense before senior architects.',
          project: 'Outcome: Staff/Senior Systems Role'
        }
      ]
    },
    backend: {
      title: 'Scalable Backend Architect',
      steps: [
        {
          num: '01',
          phase: 'Phase 1: Protocols',
          title: 'Network & APIs',
          desc: 'TCP socket buffers, epoll/kqueue, HTTP/3 QUIC, WebSocket multiplexing, and resilient REST/gRPC.',
          project: 'Project: Low-Latency API Gateway'
        },
        {
          num: '02',
          phase: 'Phase 2: Data',
          title: 'Distributed Databases',
          desc: 'B-Trees vs LSM Trees, WAL replication, partition sharding, and connection pooling with PgBouncer.',
          project: 'Project: Sharded Multi-Tenant Store'
        },
        {
          num: '03',
          phase: 'Phase 3: Streaming',
          title: 'Kafka & Event Sourcing',
          desc: 'Partition management, transactional outbox pattern, Debezium CDC, and Saga orchestrations.',
          project: 'Project: Distributed Payment Engine'
        },
        {
          num: '04',
          phase: 'Phase 4: Capstone',
          title: 'Large-Scale System Design',
          desc: 'CAP theorem in practice, rate limiters, caching stampede mitigation, and chaos recovery drills.',
          project: 'Outcome: Lead Backend Engineer'
        }
      ]
    },
    cloud: {
      title: 'Cloud & Platform SRE',
      steps: [
        {
          num: '01',
          phase: 'Phase 1: Systems',
          title: 'Linux & Containers',
          desc: 'Linux process trees, cgroups, network namespaces, rootless Docker builds, and multi-stage hardening.',
          project: 'Project: Distroless Container Suite'
        },
        {
          num: '02',
          phase: 'Phase 2: Orchestration',
          title: 'Kubernetes Clustering',
          desc: 'Control plane internals, StatefulSets, Ingress controllers, automated TLS, and modular Helm charts.',
          project: 'Project: High-Availability K8s Cluster'
        },
        {
          num: '03',
          phase: 'Phase 3: Automation',
          title: 'Terraform & GitOps',
          desc: 'Terraform state orchestration on AWS, automated GitHub Actions pipelines, and ArgoCD continuous delivery.',
          project: 'Project: Automated IaC GitOps Pipeline'
        },
        {
          num: '04',
          phase: 'Phase 4: Observability',
          title: 'SRE & Reliability',
          desc: 'Prometheus metrics scraping, Grafana dashboards, distributed tracing with Jaeger, and disaster failover drills.',
          project: 'Outcome: Site Reliability Engineer (SRE)'
        }
      ]
    }
  };

  const currentPathway = pathways[activeTab];

  return (
    <section className="roadmaps-section" id="roadmaps">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-tag">
            <span className="badge-pill badge-pill-cyan">Structured Pathways</span>
          </div>
          <h2 className="section-title">Engineering Career Roadmaps</h2>
          <p className="section-desc">
            Follow a proven architectural progression designed to take you from foundational mechanics to distributed production deployments.
          </p>
        </div>

        <div className="roadmap-tabs-row">
          <button
            type="button"
            className={`roadmap-tab-btn ${activeTab === 'systems' ? 'active' : ''}`}
            onClick={() => setActiveTab('systems')}
          >
            Systems &amp; Rust Engineer
          </button>
          <button
            type="button"
            className={`roadmap-tab-btn ${activeTab === 'backend' ? 'active' : ''}`}
            onClick={() => setActiveTab('backend')}
          >
            Scalable Backend Architect
          </button>
          <button
            type="button"
            className={`roadmap-tab-btn ${activeTab === 'cloud' ? 'active' : ''}`}
            onClick={() => setActiveTab('cloud')}
          >
            Cloud &amp; Platform SRE
          </button>
        </div>

        <div className="roadmap-view active">
          <div className="roadmap-steps-grid">
            {currentPathway.steps.map((step, idx) => (
              <div className="roadmap-step-card" key={idx}>
                <div className="step-num-pill">{step.num}</div>
                <span className="step-phase">{step.phase}</span>
                <h4 className="step-title">{step.title}</h4>
                <p className="step-desc">{step.desc}</p>
                <div className="step-project-badge">{step.project}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Roadmaps;
